export default {
  buildType: 'test',
  serverEndpoint: 'https://test.api.wagons.cn',
  openinstallAppKey: 'o0chzd',
  jdPrefix: 'https://opencredit-yf.jd.com',
};
